module.exports = __webpack_public_path__ + "static/media/MAYO-LIMONES copia.f12b8acd.webp";